import moment from 'moment'
import loggingService from './loggingService'
import _ from 'lodash/lodash.min.js'

var serviceName = 'dateService'
var isDebug = false

var standardDateFormat = 'YYYY-MM-DD HH:mm:ss'
var standardDateOnly = 'YYYY-MM-DD'

function convertToDate (value) {
    if (!value) {
        loggingService.log(isDebug, serviceName, 'convertToDate(' + value + ' -> null)')
        return null
    }

    if (value === '') {
        loggingService.log(isDebug, serviceName, 'convertToDate(' + value + ' -> null)')
        return null
    }

    var result = moment(value)
    loggingService.log(isDebug, serviceName, 'convertToDate(' + value + ' -> ' + result + ')')
    return result
}

function toString (value) {
    //This requires a json date format
    return moment(String(value), moment.ISO_8601).format(standardDateFormat)
}

function toDateString (value) {
    return moment(String(value), moment.ISO_8601).format(standardDateOnly)
}

function toStringNow (value) {
    //This requires a json date format
    return fromMomentToString(moment())
}

function fromMomentToString (value) {
    return value.format(standardDateFormat)
}

function convertListWithModifiedDates (list) {
    _.forEach(list, function (value, key) {
        value.createdDate = convertToDate(value.createdDate)
        value.modifiedDate = convertToDate(value.modifiedDate)
    })
}

function getDurationHumanized (startDate, endDate) {
    return moment.duration(endDate.diff(startDate)).humanize()
}

export default {
    convertToDate: convertToDate,
    toString: toString,
    fromMomentToString: fromMomentToString,
    toStringNow: toStringNow,
    convertListWithModifiedDates: convertListWithModifiedDates,
    getDurationHumanized: getDurationHumanized,
    toDateString: toDateString
}



// WEBPACK FOOTER //
// ./src/services/util/dateService.js